/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Pvgesamtbeitrag1Inputs */



/**

* @param {_Field_Pvgesamtbeitrag1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_pvgesamtbeitrag1 = /** @type {((inputs?: _Field_Pvgesamtbeitrag1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Pvgesamtbeitrag1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("PV-Gesamtbeitrag")
});
export { _field_pvgesamtbeitrag1 as "_field_pvGesamtbeitrag" }